import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router';
import { useFlowium } from '../client/FlowiumContext';
import AuthLayout from '../layout/AuthLayout';
import Button from '../components/Button';

const Verify = () => {
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('');
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { client } = useFlowium();

    useEffect(() => {
        const verifyEmail = async () => {
            const token = searchParams.get('token');
            if (!token) {
                setStatus('error');
                setMessage('Invalid verification link');
                return;
            }

            try {
                await client.verifyEmail(token);
                setStatus('success');
                setMessage('Email verified successfully!');
                setTimeout(() => navigate('/login'), 3000);
            } catch (error) {
                setStatus('error');
                setMessage('Failed to verify email. Please try again.');
            }
        };

        verifyEmail();
    }, [searchParams, navigate, client]);

    return (
        <AuthLayout title="Email Verification">
            <div className="flex flex-col items-center justify-center flex-1 p-4">
                <div className="bg-surface p-8 rounded-lg shadow-md text-center max-w-md w-full">
                    {status === 'loading' && <p>Verifying your email...</p>}
                    {status === 'success' && (
                        <>
                            <p className="text-success mb-4">{message}</p>
                            <Button onClick={() => navigate('/login')}>Go to Login</Button>
                        </>
                    )}
                    {status === 'error' && (
                        <>
                            <p className="text-error mb-4">{message}</p>
                            <Button onClick={() => navigate('/login')}>Go to Login</Button>
                        </>
                    )}
                </div>
            </div>
        </AuthLayout>
    );
};

export default Verify;
